import { UserPathsAnalytics } from '../components/analytics/UserPathsAnalytics'


export const AnalyticsPage = () => {
  return (
    <div className="space-y-8">
     
      <UserPathsAnalytics />
    </div>
  )
} 